import Vue from 'vue'

export const PushNotificationService = {
  subscribe (params) {
    return Vue.axios.post('/notifications/subscribe', {'token': params})
  },

  unsubscribe (params) {
    return Vue.axios.post('/notifications/unsubscribe', {'token': params})
  }
}
